const pagesPeopleOperationActivityEn = {
  clearActivityTypeFilter: 'Clear activity type filter',
  filterByActivityType: 'Filter by activity type',
  filterByDate: 'Filter by date range',
  filterByPerson: 'Filter by person',
  pageTitle: 'Operation Activity',
  showSummary: 'Show Summary',
  summary: {
    events: 'events',
    fiscalYear: 'This Fiscal Year',
    noActivity: 'No activity',
    thisMonth: 'This Month',
    thisWeek: 'This Week'
  },
  systemActor: 'System'
};
export default pagesPeopleOperationActivityEn;